import React from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { IoSpeedometerOutline } from 'react-icons/io5';
import './PlaybackRateButton.css'; // Ensure this CSS file is correctly linked

export function PlaybackRateButton({ size = 40, color = "#D9D9D9", background_color="#2A2A2A" }) {
    const { playbackRate, setPlaybackRate } = useAudio();

    const rates = [0.5, 0.75, 1, 1.25, 1.5, 2];
    const currentIndex = rates.indexOf(playbackRate);
    const nextRate = () => rates[(currentIndex + 1) % rates.length];

    const handleClick = () => {
        setPlaybackRate(nextRate());
    };

    return (
        <button onClick={handleClick} className="playbackRateButton" title={`Playback Speed: ${playbackRate}x`}>
            <IoSpeedometerOutline color={color} size={size} />
            <span className="rateNumber" style={{color:color, backgroundColor:background_color, fontSize:`${size/2.5}px`}}>{playbackRate}x</span> {/* Display the playback rate */}
        </button>
    );
}
